<breadcrumb-navigation
  [titles]="[
    { key: 'HOME_ECATALOG' | translate, url: '/ecatalog' },
    { key: 'PRODUCT_DETAIL' | translate, url: '' }
  ]"
  [needHome]="false"
></breadcrumb-navigation>
<div
  class="flex items-center cursor-pointer"
  style="padding: 0 2rem"
  (click)="backFromProductDetail()"
>
  <svg-icon [iconName]="'new/back-left.svg'" class="mr-1 ml-[-6px]"></svg-icon
  >{{ "BACK" | translate }}
</div>
<div class="product-detail mx:block sm:hidden">
  <div class="flex gap-x-8">
    <div class="left flex-1">
      <!-- big img-->
      <div class="main-img cursor-pointer" (click)="isVisible = true">
        <ng-container *ngIf="productInfo?.images?.length > 0">
          <img [src]="imgUrl" class="picture" />
        </ng-container>
        <div class="picture-wrap" *ngIf="productInfo?.images?.length == 0">
          <img src="assets/picture.svg" class="picture" />
        </div>
      </div>
      <!-- small img-->
      <div
        class="img-wrap mt-6 flex items-center"
        *ngIf="productInfo?.images?.length > 0"
      >
        <svg-icon
          [iconName]="'left_arrow.svg'"
          [size]="30"
          class="cursor-pointer left_arrow"
          *ngIf="productInfo?.images?.length >= 6"
          (click)="scrollLeft()"
        ></svg-icon>
        <svg-icon
          [iconName]="'left_arrow_grey.svg'"
          [size]="30"
          class="left_arrow"
          *ngIf="productInfo?.images?.length < 6 || currentIndex == 0"
        ></svg-icon>
        <svg-icon
          [iconName]="'right_arrow.svg'"
          [size]="30"
          class="cursor-pointer right_arrow"
          *ngIf="productInfo?.images?.length >= 6"
          (click)="scrollRight()"
        ></svg-icon>
        <svg-icon
          [iconName]="'right_arrow_grey.svg'"
          [size]="30"
          class="right_arrow"
          *ngIf="
            productInfo?.images?.length < 6 ||
            currentIndex >= this.productInfo?.images.length - 5
          "
        ></svg-icon>
        <div class="img-wrap-list">
          <ul class="list" [ngStyle]="{ 'left.px': -currentIndex * itemWidth }">
            <li *ngFor="let item of productInfo?.images; let i = index">
              <img
                [src]="item.imageURL100"
                (click)="goPic(item.imageURL800)"
                class="cursor-pointer"
              />
            </li>
          </ul>
        </div>
      </div>
      <div
        class="tabs flex-between mt-6"
        *ngIf="
          productInfo?.oemNumbers?.length > 0 && mergedCriteria?.length > 0
        "
      >
        <ul class="flex">
          <li
            *ngIf="productInfo?.oemNumbers?.length > 0"
            [class]="{ active: activeTab == 'oeNumber' ? true : false }"
            (click)="scrollToAnchor('oeNumber')"
          >
            {{ "OE_NUMBER" | translate }}
          </li>
          <li
            *ngIf="mergedCriteria?.length > 0"
            [class]="{ active: activeTab == 'criteria' ? true : false }"
            (click)="scrollToAnchor('criteria')"
          >
            {{ "CRITERIA" | translate }}
          </li>
        </ul>
      </div>
      <div
        class="oe_wrap"
        id="oeNumber"
        *ngIf="productInfo?.oemNumbers?.length > 0"
      >
        <div class="flex-between oe-select-wrap">
          <span class="font-bold">{{ "OE_NUMBER" | translate }}</span>
          <nz-select
            name="select-validate"
            [ngModel]="carType"
            (ngModelChange)="onCarTypeChange($event)"
            class="bosch-select w-[250px]"
            [nzSuffixIcon]="suffixSearch"
          >
            <nz-option
              *ngFor="let item of mfrNameOptions; let i = index"
              [nzValue]="item"
              [nzLabel]="item"
            >
            </nz-option>
            <ng-template #suffixSearch
              ><i class="search-arrow"></i
            ></ng-template>
          </nz-select>
        </div>
        <div class="color-blue line">
          <div class="py-4" *ngFor="let mfrName of mfrNameMap[carType]">
            {{ mfrName.articleNumber }}
          </div>
        </div>
      </div>
      <div class="criteria" id="criteria" *ngIf="mergedCriteria?.length > 0">
        <div class="font-bold criteria-title">{{ "CRITERIA" | translate }}</div>
        <div
          class="flex-between line py-4"
          *ngFor="let criteria of mergedCriteria"
        >
          <div class="flex items-center">
            <svg-icon
              [iconName]="'new/arrows-x-y-z.svg'"
              class="mr-6"
            ></svg-icon>
            <span class="font-bold">{{
              criteria.criteriaAbbrDescription
            }}</span>
          </div>
          <span
            >{{ criteria.formattedValue }}
            {{ criteria.criteriaUnitDescription }}</span
          >
        </div>
      </div>
    </div>
    <div class="right flex-1">
      <div class="detail">
        <div>{{ productInfo?.articleNumber }}</div>
        <div class="product font-bold">
          {{ productInfo?.genericArticles?.[0]?.genericArticleDescription }}
          <span *ngIf="productInfo?.misc?.additionalDescription">
            | {{ productInfo?.misc?.additionalDescription }}</span
          >
        </div>
        <div class="flex attr mt-14" *ngIf="productInfo?.mfrName">
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold">{{ "BRAND" | translate }}</span>
          <span>{{ productInfo?.mfrName }}</span>
        </div>
        <div class="flex attr" *ngIf="productInfo?.typeFormular">
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold"> {{ "ALIAS" | translate }} </span>
          <span>{{ productInfo?.typeFormular }}</span>
        </div>
        <div class="flex attr" *ngIf="productInfo?.gtins?.length > 0">
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold">
            {{ "GTIN/EAN" | translate }}
          </span>
          <span>{{ productInfo?.gtins?.join(",") }}</span>
        </div>
        <div class="flex attr" *ngIf="productInfo?.misc?.quantityPerPackage">
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold">{{
            "PACKING_UNIT" | translate
          }}</span>
          <span>{{ productInfo?.misc?.quantityPerPackage }}</span>
        </div>
        <div
          class="flex attr"
          *ngIf="productInfo?.misc?.quantityPerPartPerPackage"
        >
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold">{{
            "QUANTITY_PER_PACKING_UNIT" | translate
          }}</span>
          <span>{{ productInfo?.misc?.quantityPerPartPerPackage }}</span>
        </div>
        <div class="flex attr" *ngIf="productInfo?.tradeNumbers?.length > 0">
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold"
            >{{ "TRADE_NUMBER" | translate }}
          </span>
          <div class="color-blue">
            <span
              class="cursor-pointer"
              *ngFor="let trade of productInfo?.tradeNumbers; let last = last"
              (click)="goSearch(trade, trade.partId)"
              >{{ trade }}{{ !last ? " / " : "" }}</span
            >
          </div>
        </div>
        <div
          class="flex attr"
          *ngIf="productInfo?.replacesArticles?.length > 0"
        >
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold">{{ "REPLACES" | translate }}</span>
          <div class="color-blue">
            <span
              class="cursor-pointer"
              *ngFor="
                let replaces of productInfo?.replacesArticles;
                let last = last
              "
              (click)="goSearch(replaces.articleNumber, replaces.partId)"
              >{{ replaces.articleNumber }}{{ !last ? " / " : "" }}</span
            >
          </div>
        </div>
        <div
          class="flex attr"
          *ngIf="productInfo?.replacedByArticles?.length > 0"
        >
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold">{{
            "REPLACED_BY" | translate
          }}</span>
          <div class="color-blue">
            <span
              class="cursor-pointer"
              *ngFor="
                let replaced of productInfo?.replacedByArticles;
                let last = last
              "
              (click)="goSearch(replaced.articleNumber, replaced.partId)"
              >{{ replaced.articleNumber }}{{ !last ? " / " : "" }}</span
            >
          </div>
        </div>
        <div
          class="flex attr"
          *ngIf="productInfo?.misc?.articleStatusDescription"
        >
          <svg-icon [iconName]="'new/attr.svg'" class="mr-6"></svg-icon>
          <span class="attribute font-bold">{{ "STATUS" | translate }}</span>
          <div>{{ productInfo.misc?.articleStatusDescription }}</div>
        </div>
        <div class="form mt-14">
          <div class="flex items-center mt20">
            <div class="form-text">{{ "ADD_QTY" | translate }}</div>
            <quantity-input
              class="form-qty"
              mode="list"
              [(quantity)]="productInfo.quantity"
              (quantityBlur)="quantityBlur($event)"
              (quantityChange)="quantityChange($event)"
            ></quantity-input>
            <span class="ml-4 text-grey700"
              >{{ "MOQ" | translate }}:{{ productInfo.minumQty }}</span
            >
          </div>
          <div class="flex items-center mt20">
            <div class="form-text">{{ "EXPECT_DATE" | translate }}</div>
            <nz-date-picker
              *ngIf="productInfo?.quantity"
              [nzAllowClear]="false"
              [nzSuffixIcon]="suffixDate"
              [(ngModel)]="productInfo.expectedDate"
              [nzPlaceHolder]="'ADD_DATE' | translate"
              class="form-date bosch-date-picker"
              nzFormat="yyyy-MM-dd"
              [nzShowToday]="false"
              [nzRenderExtraFooter]="footerRender"
              [nzDisabledDate]="disabledDate"
            ></nz-date-picker>
            <ng-container *nzSuffix><i class="beforeIcon"></i></ng-container>
            <ng-template #footerRender>
              <div class="flex-center">
                <a (click)="chooseDate(productInfo)">{{
                  "ONE_WEEK_LATER" | translate
                }}</a>
              </div></ng-template
            >
            <ng-template #suffixDate>
              <svg-icon
                [isUrl]="false"
                [iconName]="'date.svg'"
                [size]="20"
                class="color-grey"
              ></svg-icon
            ></ng-template>
          </div>
          <div
            class="flex mt20"
            *ngIf="
              productInfo?.stockQty !== null &&
              productInfo?.stockQty !== undefined &&
              isLogin
            "
          >
            <div class="form-text">{{ "STOCK" | translate }}</div>
            <svg-icon
              [iconName]="
                productInfo?.stockQty === 0
                  ? 'new/red.svg'
                  : productInfo?.quantity <= productInfo?.stockQty
                  ? 'new/green.svg'
                  : 'new/yellow.svg'
              "
            ></svg-icon>
          </div>
          <div
            class="primary-mid-btn add-cart mt-14"
            [ngClass]="{
              disabled:
                !isLogin || userData?.queryUserPageInfoResDTO?.status !== 2
            }"
            (click)="addToCart(productInfo)"
          >
            <svg-icon
              [isUrl]="false"
              [iconName]="'cart.svg'"
              class="mr6"
              [size]="20"
            ></svg-icon>
            <span>{{ "ADD_TO_CART" | translate }}</span>
          </div>
        </div>
      </div>
      <div class="vehicle mt-14" *ngIf="vehicles.length > 0">
        <div class="flex-between">
          <div class="product font-bold">
            {{ "VEHICLE_LINKAGE" | translate }}
          </div>
          <div class="color-blue cursor-pointer" (click)="showDetail('')">
            {{ "SEE_ALL" | translate }}
          </div>
        </div>
        <ul class="vehicle_list mt-4 flex-between">
          <li
            *ngFor="let item of vehicles | slice : 0 : 4"
            class="cursor-pointer"
            (click)="showDetail(item.manuId)"
          >
            <div class="text-center">
              <svg-icon [iconName]="'new/car.svg'"></svg-icon>
            </div>
            <div class="text-center mt-2">{{ item.manuName }}</div>
          </li>
          <li
            *ngFor="
              let i of [].constructor(4 - (vehicles | slice : 0 : 4).length)
            "
          ></li>
        </ul>
      </div>
    </div>
  </div>
</div>
<nz-modal
  [(nzVisible)]="isVisible"
  [nzWidth]="628"
  [nzFooter]="null"
  (nzOnCancel)="isVisible = false"
>
  <ng-container *nzModalContent>
    <img class="img-preview" [src]="imgUrl" alt="image preview" />
  </ng-container>
</nz-modal>
<vehicle-modal
  (handleClose)="handleClose()"
  [isVehicleVisible]="isVehicleVisible"
  [brand]="brand"
  [articleId]="productInfo?.genericArticles?.[0].legacyArticleId"
  [vehicles]="vehicles"
></vehicle-modal>

<app-product-mobile-detail
  class="sm:block mx:hidden"
></app-product-mobile-detail>
